import { Injectable } from "@angular/core";
import { GlobalStateModel, GSM } from "./app.global.model";

@Injectable()
export class GlobalState {
  private _state: GlobalStateModel;

  get state() {
    return (this._state = this.clone(this._state));
  }

  set state(v) {
    throw new Error("不允许直接修改全局变量库---_state");
  }

  /**
   * 初始化state 只能通过该方法初始化
   * @param state 初始化state
   */
  init(state: GlobalStateModel) {
    this._state = state;
  }

  /**
   * 全局变量名为空则返回所有
   * @param key 全局变量名
   */
  get(key?: any): any {
    const state = this.state;
    return state.hasOwnProperty(key) ? state[key] : null;
  }

  set(key: any, value: any) {
    if (GSM.hasOwnProperty(key)) return (this._state[key] = value);
    return console.error(
      "未定义的global属性！先在app.global.model中定义该属性才能修改",
    );
  }

  private clone(obj) {
    //反回一个拷贝的简单对象
    if (!obj) return {};
    return JSON.parse(JSON.stringify(obj));
  }
}



// WEBPACK FOOTER //
// ./src/services/common/app/global/app.global.ts